import { render, staticRenderFns } from "./NewScoringRequest.vue?vue&type=template&id=b26c28ee&lang=pug&"
import script from "./NewScoringRequest.vue?vue&type=script&lang=js&"
export * from "./NewScoringRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports